import { computed, defineComponent, watch } from 'vue';
import { ErrorMessage, FieldContext } from 'vee-validate';
import { first } from 'lodash-es';

export default defineComponent({
  name: 'dl-form-field',
  components: { ErrorMessage },
  props: {
    field: {
      type: Object as () => { key: string; label: string; field: FieldContext },
      default: () => ({ key: '', label: '', field: undefined as unknown as FieldContext }),
      required: false
    },
    name: { type: String, required: false, default: undefined },
    for: { type: String, required: false, default: undefined },
    labelBefore: { type: Boolean, default: false, required: false },
    modHiddenLabel: { type: Boolean, default: false, required: false },
    modRequired: { type: Boolean, default: false, required: false }
  },
  setup(props) {
    const errorMessage = computed(() => first(props.field?.field?.errors?.value));
    const isValidated = computed(() => props.field?.field?.meta?.validated);
    const hasErrors = computed((): boolean => !!errorMessage?.value && isValidated.value);
    const hasSuccess = computed((): boolean => !errorMessage.value && isValidated.value);
    const label = computed((): string => props.name || props.field?.label || '\u00A0'); // non-breaking space to ensure the label takes up space even if it's empty
    const labelFor = computed((): string => {
      return props.for;
    });

    const classes = computed(() => ({
      'dl-form-field--error': hasErrors.value,
      'dl-form-field--success': hasSuccess.value
    }));

    return {
      label,
      labelFor,
      hasErrors,
      errorMessage,
      classes
    };
  }
});
